import { apiRequest } from "../../lib/api";
// import { TCatalog } from "../types/TCatalog";
import { TLink } from "../types/TLink";
import { Socket } from "socket.io-client";
import { CustomError } from "../../lib/CustomError";
import {
  FinalEvent,
  SearchEvent,
  SearchEventType,
  StatusEvent,
  UnrankedEvent,
  ResultDataKeys,
} from "../types/SearchEvent";

export async function getCatalog(): Promise<Record<string, any[]>> {
  return apiRequest({ method: "get", url: "/catalogue/catalogue/domain-asset-field", params: { type: "canvas" } });
}

export async function getLinks(): Promise<TLink[]> {
  return apiRequest({ method: "get", url: "/catalogue/link" });
}

export async function deleteRelationship(
  node_id1: number,
  node_id2: number
): Promise<{ id: number }> {
  return apiRequest({
    method: "delete",
    url: `/catalog/links`,
    data: {
      source_id: node_id1,
      target_id: node_id2,
    },
  });
}

export async function addRelationship(
  node_id1: number,
  node_id2: number,
  intersect_count: number,
  accuracy: number
): Promise<{ id: number }> {
  return apiRequest({
    method: "post",
    url: `/catalog/links`,
    params: {
      intersect_count,
      accuracy,
    },
    data: {
      source_id: node_id1,
      target_id: node_id2,
    },
  }).then((res) => {
    return res;
  });
}

export async function getRelationshipData(
  node_id1: number,
  node_id2: number,
  subscription_id: number,
  socket?: Socket
): Promise<{
  records_mapped: {
    source_count: number;
    target_count: number;
    records_mapped: number;
    target_count_distinct: number;
    source_count_distinct: number;
  };
  token: string;
}> {
  const listening = `mapped_records_${node_id1}_${node_id2}`;

  socket?.emit("mapped_records", {
    subscription_id: subscription_id,
    source_id: node_id1,
    target_id: node_id2,
    return_val: {
      listening,
    },
  });

  let data: {
    records_mapped: {
      source_count: number;
      target_count: number;
      records_mapped: number;
      target_count_distinct: number;
      source_count_distinct: number;
    };
    token: string;
  } = await new Promise((resolve) => {
    socket?.once(listening, (response) => {
      // let res = columnarToRecords(response.data);
      let records_mapped = response.data;
      let token = response.token;
      records_mapped = {
        source_count: records_mapped["source_count"][0],
        source_count_distinct: records_mapped["source_count_distinct"][0],
        target_count: records_mapped["target_count"][0],
        target_count_distinct: records_mapped["target_count_distinct"][0],
        records_mapped: records_mapped["records_mapped"][0],
      };
      resolve({
        records_mapped,
        token,
      });
    });
  });

  return data;
}

function sleep(ms: number) {
  return new Promise((res) => setTimeout(res, ms));
}

// export async function* run_semantic_search_v2(
//   subscription_id: string,
//   searchText: string
// ): AsyncGenerator<any> {
//   const eventSource = new EventSource(
//     `${API_URL}/semantic_search/search?subscription_id=${encodeURI(subscription_id)}&query=${encodeURI(searchText)}`
//   )
//
//   eventSource.onmessage = (event: MessageEvent) => {
//   }
// }
//

/**
 * Stub function for semantic search
 * @param {string} searchText - text send for semantic search
 * @returns {AsyncGenerator<SearchEvent>}
 * @example
 * for await (const result of run_semantic_search(local_input))
 */
export async function* run_semantic_search(
  _: string
): AsyncGenerator<SearchEvent> {
  await sleep(2000);
  const unrankedEvent: UnrankedEvent = {
    event_type: SearchEventType.UNRANKED,
    data: {
      [ResultDataKeys.HIGH]: [
        1770, 1761, 1822, 1823, 1889, 1711, 1738, 1732, 1777, 2412, 1784, 1846,
        1721, 1765, 1787, 1720, 1949,
      ],
      [ResultDataKeys.LOW]: [
        1914, 1796, 1892, 1768, 1780, 1742, 1772, 1947, 1733, 1880, 1909, 1743,
        1753,
      ],
    },
  };
  yield unrankedEvent;
  for (let i = 10; i <= 100; i += 10) {
    const progress1: StatusEvent = {
      event_type: SearchEventType.PROGRESS,
      data: {
        completed: i,
        total: 100,
      },
    };
    yield progress1;
    await sleep(1000);
  }

  const finalEvent: FinalEvent = {
    event_type: SearchEventType.FINAL,
    data: {
      [ResultDataKeys.HIGH]: [
        1777, 2412, 1784, 1846, 1721, 1765, 1787, 1720, 1949,
      ],
      [ResultDataKeys.LOW]: [1733, 1880, 1909, 1743, 1753],
    },
  };
  yield finalEvent;
}

// export async function run_semantic_search(searchText: string) {
//   return apiRequest({
//     method: 'get',
//     url: '/semantic_search/search',
//     params: {
//       query: searchText
//     }
//   }).catch((error) => {
//       throw CustomError.fromAxiosError(error);
//   })
// }

export function get_column_info(id: number) {
  return apiRequest({
    url: `/catalogue/field/${id}`,
  });
}

export function get_table_info(id: number) {
  return apiRequest({
    url: `catalogue/asset/${id}/asset_preview`,
    params: { id },
  });
}

// export function run_semantic_search(searchText: string) {
//   return new Promise((res, rej) => {
//     const randomTime = Math.round(Math.random() * 4) + 6;
//     const randomFail = Math.round(Math.random())
//     setTimeout(() => {
//       if(randomFail)
//         rej(undefined)
//       else
//         res([1489, 1499, 1501, 1502])
//     }, randomTime);
//   })
// }

export async function getDataPreview(
  id: number,
  controller: AbortController,
  _type: string = "column"
): Promise<{}[]> {
  return apiRequest({
    url: `/catalogue/field/${id}/sample_preview`,
    signal: controller.signal,
  })
    .then((resData) => {
      let keys = Object.keys(resData);
      if (keys.length == 0) return [];
      let field = keys[0];
      let data: {}[] = resData[field].map((d: string) => ({
        [field]: d,
      }));
      return data;
    })
    .catch((error) => {
      throw CustomError.fromAxiosError(error);
    });
}

export async function getCheckSemanticSearchInitialization(): Promise<
  "OPEN" | "ERROR" | "SUCCESS" | "RUNNING"
> {
  return apiRequest({
    url: "/semantic_search/status",
  }).then((resData) => {
    if (
      resData.semantic_search_initialization_status &&
      resData.semantic_search_initialization_status != ""
    ) {
      return resData.semantic_search_initialization_status;
    }
    return "OPEN";
  });
}

export async function postInitiaizeSemanticSearch() {
  return apiRequest({
    method: "post",
    url: "/semantic_search/refresh",
  });
}
